/* eslint-disable no-nested-ternary */
import {
  Button,
  FlexGroup,
  FlexItem,
  Health,
  Icon,
  IconTip,
  Modal,
  ModalBody,
  ModalHeader,
  ModalHeaderTitle,
  notification,
  Outline,
  Popover,
  Text,
  Title,
  ModalFooter,
  ButtonEmpty,
  SuperSelect,
  Badge,
  ToolTip,
  ButtonIcon,
} from '@antoree/ant-ui';

import absenceNotice from 'assets/icons/absence-notice.svg';
import warning from 'assets/icons/warning.svg';
import {
  AbsenceReasonModal,
  ConfirmSession,
  CountdownTimer,
  JoinCall,
  PeriodicalEvaluation,
  SessionActions,
  TestResult,
} from 'components';
import { CourseType, TESTING_TYPE, TRIAL_TYPE } from 'constants/courses';
import {
  ABSENT_BY_TEACHER,
  HAPPENED,
  HAPPENING,
  SESSION_STATUS,
  UNHAPPENED,
  UPCOMING,
} from 'constants/session';
import { useCurrentUser } from 'contexts';
import { useScreenRecorder } from 'contexts/ScreenRecorderContext';
import { useToggle } from 'hooks';
import moment from 'moment-timezone';
import {
  Fragment,
  useCallback,
  useEffect,
  useMemo,
  useState,
  useRef,
} from 'react';
import { FormattedDate, FormattedMessage, useIntl } from 'react-intl';
import { useHistory } from 'react-router-dom';
import {
  useCancelSession,
  useConfirmSession,
  useRetrieveSessionById,
  useSendConfirmationRequest,
  useUndoAbsentSession,
} from 'services';
import { useConfirmNoSession } from 'services/session/confirmNoSession';
import { Session } from 'services/session';
import { useUpdateSession } from 'services/session/editSession';
import { foundUnitStatus } from 'utils/unitUtils';
import { getScheduleConflictOrMessage } from 'utils/scheduleConflictMessages';
import { SlotTimeSelectedType } from 'configs/types';
import Notice from 'components/Notice';
import AlertModal from '../AlertAbsenceModal';
import {
  ABSENCE_TYPES,
  MAKE_UP_CLASS_BY_STUDENT,
  MAKE_UP_CLASS_BY_TEACHER,
  PENALTY_LATE,
  PENALTY_TYPE,
  RATE_70,
} from '../constants';
import EditSession from '../EditSession';
import AddSessionContent from '../SessionContent';
import AttendanceModal from '../AttendanceModal';
import SessionContent from '../SessionContent';
import { SessionContentHandle } from '../SessionContent/SessionContent';
import { TestResultHandle } from '../TestResult/TestResult';

export type SessionCardProps = {
  children?: React.ReactNode;
  courseType: CourseType | undefined;
  session: Session;
};

const SessionCard: React.FC<SessionCardProps> = ({
  session: sessionProp,
  courseType,
}) => {
  moment.tz.setDefault('Asia/Bangkok');
  const { formatMessage } = useIntl();
  const idTest = [179266, 286234, 187737, 206144];
  const STATUS_WAITING_CONFIRM = 4;

  const STATUS_WAITING_STUDENT_CONFIRM = 5;
  const Reasons = [
    {
      id: 1,
      value: '1',
      inputDisplay: <FormattedMessage defaultMessage="I had urgent business" />,
    },
    {
      id: 2,
      value: '2',
      inputDisplay: (
        <FormattedMessage defaultMessage="Student did not appear" />
      ),
    },
  ];
  const history = useHistory();
  const { id } = useCurrentUser();
  const {
    close: closeEditSessionModal,
    isVisiable: isVisibleEditSessionModal,
    open: openEditSessionModal,
  } = useToggle();
  // const {
  //   close: closeAlertPenaltyAbsence,
  //   isVisiable: isVisibleAlertPenaltyAbsence,
  //   open: openAlertPenaltyAbsence,
  // } = useToggle();
  const {
    isVisiable: isVisibleConfirmModal,
    open: openConfirmModal,
    close: closeConfirmModal,
  } = useToggle();
  const {
    isVisiable: isVisibleReceive50,
    open: openReceive50Modal,
    close: closeReceive50Modal,
  } = useToggle();
  const {
    isVisiable: isVisibleAttendance,
    open: openAttendanceModal,
    close: closeAttendanceModal,
  } = useToggle();

  const handleOpenAttendanceModal = () => {
    globalAutoOpenedSessions.add(session.id);
    openAttendanceModal();
  };

  const sessionContentRef = useRef<SessionContentHandle>(null);
  const testResultRef = useRef<TestResultHandle>(null);
  const [isOpenPopoverReason, setOpenPopoverReason] = useState<boolean>(false);
  const [isStartingRecording, setIsStartingRecording] = useState(false);
  const [hasAutoOpened, setHasAutoOpened] = useState(false);

  const [session, setSession] = useState<Session>(sessionProp);
  const [isEnabledSession, setIsEnabledSession] = useState(false);
  const {
    startRecording,
    stopRecording,
    requestStopRecording,
    recordingStatus,
    activeSessionId,
  } = useScreenRecorder();
  const { id: currentUserId } = useCurrentUser();
  const isTrialOrTestingCourse =
    courseType?.value === TRIAL_TYPE || courseType?.value === TESTING_TYPE;

// Global set to track which sessions have already been auto-opened to prevent duplicates
// when the same session is rendered in multiple places (e.g. TodayCourses and AllCourses)
const globalAutoOpenedSessions = new Set<number>();

  // Automatically open AttendanceModal when class starts and ring alarm
  useEffect(() => {
    if (!session || session.studentCheckIn || hasAutoOpened) return;

    const interval = setInterval(() => {
      const now = moment();
      const start = moment(session.occurredAt);
      const diffMinutes = now.diff(start, 'minutes', true);
      
      if (diffMinutes >= 0 && diffMinutes <= 15) {
         if (globalAutoOpenedSessions.has(session.id)) {
           setHasAutoOpened(true);
           return;
         }
         
         globalAutoOpenedSessions.add(session.id);
         setHasAutoOpened(true);
         
         if (!isVisibleAttendance) {
           openAttendanceModal();
           try {
             // Custom notification sound
             const audio = new Audio('/audios/notification_message-notification-6-337829.mp3');
             audio.volume = 1.0;
             audio.play().catch(e => console.log('Audio play failed', e));
           } catch (error) {}
         }
      }
    }, 10000);
    return () => clearInterval(interval);
  }, [session, hasAutoOpened, isVisibleAttendance, openAttendanceModal]);

  const handleViewRecordings = useCallback(() => {
    if (isTrialOrTestingCourse && testResultRef.current) {
      testResultRef.current.open();
      return;
    }
    if (sessionContentRef.current) {
      sessionContentRef.current.open();
    }
  }, [isTrialOrTestingCourse]);
  const { isCourseUnit: isUnit } = session;
  const { ClockIcon: ClockIconOutline } = Outline;
  const sessionStatus = isUnit
    ? foundUnitStatus(session?.happenedStatus)
    : SESSION_STATUS.find(item => item?.value === session?.happenedStatus);

  const renderHappenStatus = () => {
    if (sessionStatus?.label) {
      if (sessionStatus.value === HAPPENING) {
        if (session.status === STATUS_WAITING_CONFIRM) {
          return (
            <p>
              <FormattedMessage defaultMessage="Teacher confirming" />
            </p>
          );
        }
        if (session.status === STATUS_WAITING_STUDENT_CONFIRM) {
          return (
            <p>
              <FormattedMessage defaultMessage="Student Verifying" />
            </p>
          );
        }
      }
      return (
        <p>
          <FormattedMessage {...sessionStatus?.label} />
        </p>
      );
    }
    return <FormattedMessage defaultMessage="Unknown" />;
  };

  const { mutate: mutateUndo, isLoading } = useUndoAbsentSession({
    onSuccess: data => {
      setSession(data?.data?.sessions);
      notification.success({
        title: <FormattedMessage defaultMessage="Undo successful" />,
      });
    },
    onError: error => {
      notification.error({
        title: <FormattedMessage defaultMessage="Undo failed" />,
        text: <p>{error?.response?.data?.errors[0]?.message}</p>,
      });
    },
  });
  const { data: dataRes } = useRetrieveSessionById(
    { id: session?.id },
    {
      enabled: isEnabledSession,
      cacheTime: 0,
      refetchOnWindowFocus: false,
    },
  );
  const isPenalty = () => {
    const hourBetween = moment.duration(
      moment(session?.occurredAt).diff(moment()),
    );
    const before3Hours = moment.duration(
      moment().add(3, 'hours').diff(moment()),
    );

    return hourBetween < before3Hours;
  };

  const handleUndoAbsentSession = useCallback((issueId: number) => {
    mutateUndo({
      courseId: session?.course_id,
      sessionId: session?.id,
      issueId,
    });
  }, []);

  const handleReloadSession = (sessionParam: Session) => {
    if (sessionParam) {
      setSession(sessionParam);
    }
  };

  const {
    isVisiable: isVisiableAbsenceReason,
    toggle: openAbsenceReason,
    close: closeAbsenceReason,
  } = useToggle();

  const {
    mutate: mutateCancelSession,
    isLoading: isLoadingConfirmSession,
  } = useCancelSession({
    onSuccess: data => {
      setSession(data?.data?.sessions);
      notification.success({
        title: <FormattedMessage defaultMessage="Cancel successful" />,
      });
      closeAbsenceReason();
    },
    onError: error => {
      notification.error({
        title: <FormattedMessage defaultMessage="Cancel failed" />,
        text: <p>{error?.response?.data?.errors[0]?.message}</p>,
      });
    },
  });
  const {
    mutate: mutateUpdateSession,
    isLoading: isLoadingUpdateSession,
  } = useUpdateSession({
    onSuccess: res => {
      notification.success({
        title: <FormattedMessage defaultMessage="Update session successful" />,
      });

      handleReloadSession(res?.data?.session);
      closeEditSessionModal();
    },
    onError: errors => {
      const { lines, fallback } = getScheduleConflictOrMessage(
        errors,
        formatMessage,
      );
      if (lines.length) {
        notification.error({
          title: lines[0],
          text:
            lines.length > 1 ? (
              <Fragment>
                {lines.slice(1).map((line, i) => (
                  <p key={i} style={{ marginTop: 6 }}>
                    {line}
                  </p>
                ))}
              </Fragment>
            ) : undefined,
        });
        return;
      }
      notification.error({
        title: <FormattedMessage defaultMessage="Error" />,
        text: fallback ?? (
          <FormattedMessage defaultMessage="Update session fail!" />
        ),
      });
    },
  });
  const handleConfirmAbsent = (
    absenceReason: string,
    schedules?: SlotTimeSelectedType[],
  ) => {
    mutateCancelSession({
      courseId: session?.course_id,
      sessionId: session?.id,
      _absent: 1,
      content: absenceReason,
      schedules,
    });
  };
  const handleUpdateSession = (duration: number, occurredAt: string) => {
    mutateUpdateSession({ duration, occurredAt, sessionId: session?.id });
  };

  // reload session when create test result success
  useEffect(() => {
    if (dataRes?.data?.session) setSession(dataRes?.data?.session);
  }, [dataRes]);
  const confirmSessionMutation = useConfirmSession({
    onSuccess: res => {
      notification.success({
        title: <FormattedMessage defaultMessage="Confirm session success" />,
      });
      handleReloadSession(res?.data?.session);
      closeConfirmModal();
    },
    onError: err => {
      const mesError = err?.response?.data?.errors[0]?.message;

      notification.error({
        title: <FormattedMessage defaultMessage="Confirm session failed" />,
        text: `${mesError}`,
      });
    },
  });
  const {
    mutate: mutateSendConfirmationRequest,
    isLoading: isLoadingSendConfirmationRequest,
  } = useSendConfirmationRequest({
    onSuccess: res => {
      notification.success({
        title: (
          <FormattedMessage defaultMessage="send confirmation request successful" />
        ),
        text: (
          <FormattedMessage defaultMessage="The request has been sent to your student. The session will be added to the course as your student confirms." />
        ),
      });
      handleReloadSession(res?.data?.session);
      closeConfirmModal();
    },
    onError: err => {
      const mesError = err?.response?.data?.errors[0]?.message;

      notification.error({
        title: (
          <FormattedMessage defaultMessage="send confirmation request failure" />
        ),
        text: `${mesError}`,
      });
    },
  });
  const {
    mutate: mutateConfirmNo,
    isLoading: isLoadingConfirmNo,
  } = useConfirmNoSession({
    onSuccess: res => {
      notification.success({
        title: <FormattedMessage defaultMessage="Successfully" />,
      });
      handleReloadSession(res?.data?.session);
      closeReceive50Modal();
    },
    onError: err => {
      const mesError = err?.response?.data?.errors[0]?.message;

      notification.error({
        title: <FormattedMessage defaultMessage="Failure" />,
        text: `${mesError}`,
      });
    },
  });

  const handleStudentNotJoinSession = (halfSalary = 0) => {
    mutateConfirmNo({
      id: session.id,
      courseId: session.course_id,
      isUnit,
      absentType: 2,
      halfSalary,
    });
  };
  const handleClickConfirmSession = () => {
    confirmSessionMutation.mutate({
      id: session.id,
      courseId: session.course_id,
      isUnit,
    });
  };
  const handleSendConfirmationRequest = () => {
    mutateSendConfirmationRequest({
      id: session.id,
    });
  };
  // const renderTextActions = () => {
  //   if (courseType?.value === TESTING_TYPE) {
  //     return (
  //       <TestResult
  //         session={session}
  //         onReload={() => setIsEnabledSession(true)}
  //       />
  //     );
  //   }
  //   if (courseType?.value !== TESTING_TYPE) {
  //     return (
  //       <div className="flex">
  //         <SessionContent
  //           teacherId={id}
  //           session={session}
  //           view={currentUserId !== session?.teacher?.id}
  //           allowSubmit={currentUserId === session?.teacher?.id}
  //           onReload={handleReloadSession}
  //         />

  //         {courseType?.value === TRIAL_TYPE && (
  //           <>
  //             <ConfirmSession
  //               isLoading={confirmSessionMutation.isLoading}
  //               session={session}
  //               onClickConfirmSession={handleClickConfirmSession}
  //             />
  //           </>
  //         )}

  //         {session.testRequired && (
  //           <TestResult
  //             session={session}
  //             onReload={() => setIsEnabledSession(true)}
  //           />
  //         )}
  //       </div>
  //     );
  //   }
  //   return null;
  // };
  const renderTextActions = () => {
    if (
      courseType?.value === TESTING_TYPE ||
      courseType?.value === TRIAL_TYPE
    ) {
      return (
        <div className="flex">
          <TestResult
            ref={testResultRef}
            session={session}
            onReload={() => setIsEnabledSession(true)}
            autoAttachRecordedVideo
          />
        </div>
      );
    }
    return (
      <div className="flex">
        <SessionContent
          ref={sessionContentRef}
          teacherId={id}
          session={session}
          view={currentUserId !== session?.teacher?.id}
          allowSubmit={currentUserId === session?.teacher?.id}
          onReload={handleReloadSession}
        />

        {/* {courseType?.value === TRIAL_TYPE && (
            <>
              <ConfirmSession
                isLoading={confirmSessionMutation.isLoading}
                session={session}
                onClickConfirmSession={handleClickConfirmSession}
              />
            </>
          )} */}

        {session.testRequired && (
          <TestResult
            session={session}
            onReload={() => setIsEnabledSession(true)}
          />
        )}
      </div>
    );
  };

  const renderIconActions = () => {
    if (session?.hasEvaluation) {
      return (
        <PeriodicalEvaluation
          session={session}
          view={
            currentUserId !== session?.teacher?.id ||
            currentUserId !== session?.teacher?.id
          }
          allowSubmit={
            currentUserId === session?.teacher?.id ||
            currentUserId === session?.teacher?.id
          }
          onReload={(sessionRes: Session) => setSession(sessionRes)}
        />
      );
    }
    if (
      (session?.issues ||
        (session.absentType !== 0 && session.absentType !== 3)) &&
      happenedStatus === UNHAPPENED
    ) {
      return (
        <div
          onMouseEnter={() => setOpenPopoverReason(true)}
          onMouseLeave={() => setOpenPopoverReason(false)}
        >
          <Icon className="mr-2" type="alert" style={{ color: '#ED0000' }} />
          <Popover
            display="block"
            isOpen={isOpenPopoverReason}
            closePopover={() => {}}
            anchorPosition="downCenter"
            button={<></>}
          >
            <Title className="text-base font-semibold">
              {session?.absentType === ABSENT_BY_TEACHER ? (
                <p>Teacher has submitted leave of absence</p>
              ) : (
                <p>Student has submitted leave of absence</p>
              )}
            </Title>
            <Text color="subdued" style={{ fontSize: '14px' }}>
              <p>{session?.issues?.sessionAbsent?.createdAt}</p>
            </Text>

            <p style={{ width: '320px' }}>{session.absentReason}</p>
          </Popover>
        </div>
      );
    }
    return null;
  };
  const { confirmedType, absentType, happenedStatus } = session;
  const canRecordFromCard =
    isTrialOrTestingCourse && currentUserId === session?.teacher?.id;
  const isCurrentSessionRecording =
    recordingStatus === 'recording' &&
    String(activeSessionId || '') === String(session?.id || '');
  // const isOpenNoticeEndClassPopUp = useMemo(
  //   () =>
  //     moment() <
  //     moment(session.occurredAt)
  //       .add(session.duration.hours, 'hours')
  //       .add(session.duration.minutes, 'minutes'),
  //   [isVisibleAttendance],
  // );

  return (
    <FlexGroup gutterSize="none" responsive={false} style={{ height: 75 }}>
      {isVisibleEditSessionModal && (
        <EditSession
          close={closeEditSessionModal}
          isLoading={isLoadingUpdateSession}
          onUpdateSession={handleUpdateSession}
          session={session}
        />
      )}
      {/* {isVisibleAlertPenaltyAbsence && (
        <AlertModal close={closeAlertPenaltyAbsence} />
      )} */}
      {isVisibleAttendance && (
        <AttendanceModal
          close={closeAttendanceModal}
          session={session}
          view={currentUserId !== session?.teacher?.id}
          allowSubmit={currentUserId === session?.teacher?.id}
          onReload={handleReloadSession}
        />
      )}

      <FlexItem
        style={{
          backgroundColor: 'rgba(52, 55, 65, 0.05)',
          borderRadius: '8px',
        }}
        grow={9}
      >
        <FlexGroup>
          <FlexItem grow={9}>
            <FlexGroup style={{ alignItems: 'center' }}>
              <FlexItem
                grow={false}
                className="pl-2"
                style={{ minWidth: '10%' }}
              >
                {sessionStatus?.value === UPCOMING &&
                history.location.pathname === '/courses' ? (
                  <CountdownTimer occurredAt={session?.occurredAt} />
                ) : (
                  <div className="flex flex-col items-center gap-2">
                    <Health color={sessionStatus?.color}>
                      {renderHappenStatus()}
                    </Health>
                    <span>
                      {session.scheduledStatus === MAKE_UP_CLASS_BY_STUDENT && (
                        <ToolTip
                          position="top"
                          content={
                            <FormattedMessage defaultMessage="Make-up class by student" />
                          }
                        >
                          <p className="text-danger text-xs">
                            <FormattedMessage defaultMessage="Make-up" />
                          </p>
                        </ToolTip>
                      )}
                      {session.scheduledStatus === MAKE_UP_CLASS_BY_TEACHER && (
                        <ToolTip
                          position="top"
                          content={
                            <FormattedMessage defaultMessage="Make-up class by teacher" />
                          }
                        >
                          <p className="text-danger text-xs">
                            <FormattedMessage defaultMessage="Make-up" />
                          </p>
                        </ToolTip>
                      )}
                    </span>
                  </div>
                )}
              </FlexItem>
              {/* end item col 1 */}
              <FlexItem grow={false} style={{ minWidth: '15%' }}>
                <FlexGroup gutterSize="s">
                  <FlexItem grow={false}>
                    <Text>
                      <Icon type="calendar" className="mr-1" />
                    </Text>
                  </FlexItem>
                  <FlexItem>
                    {moment(session?.occurredAt).format('ddd, MMM DD YYYY')}
                  </FlexItem>
                </FlexGroup>
              </FlexItem>
              {/* end item col 2 */}
              <FlexItem grow={false} style={{ minWidth: '12%' }}>
                <FlexGroup gutterSize="xs" alignItems="center">
                  <FlexItem grow={false}>
                    <ClockIconOutline
                      className="h-5 w-5"
                      style={{ color: '#343741' }}
                    />
                  </FlexItem>
                  <FlexItem grow={false}>
                    <Text style={{ color: '#343741' }}>
                      <p>
                        {session?.shortTimeStartedAt} -{' '}
                        {session?.shortTimeEndedAt}
                      </p>
                    </Text>
                  </FlexItem>
                </FlexGroup>
              </FlexItem>
              {/* end item col 3 */}
              <FlexItem grow={false}>
                <span>
                  {session.type === PENALTY_TYPE && (
                    <ToolTip
                      position="top"
                      content={
                        <FormattedMessage defaultMessage="No salary for this session" />
                      }
                    >
                      <Badge color="#ed0000">
                        <p className="text-white">
                          <FormattedMessage defaultMessage="penalty" />
                        </p>
                      </Badge>
                    </ToolTip>
                  )}
                </span>
                <span>
                  {session.penalty_late === PENALTY_LATE && (
                    <IconTip
                      type={warning}
                      content={
                        <FormattedMessage defaultMessage="Show up late" />
                      }
                    />
                  )}
                </span>
              </FlexItem>
              <FlexItem grow={false} style={{ minWidth: '10%' }}>
                {renderTextActions()}
              </FlexItem>

              {/* end item col 4 */}
              <FlexItem
                grow={false}
                className="items-center"
                style={{ minWidth: '5%' }}
              >
                {renderIconActions()}
              </FlexItem>
              <FlexItem className="items-center justify-center">
                {confirmedType === RATE_70 && happenedStatus !== UNHAPPENED && (
                  <ToolTip
                    position="top"
                    content={
                      <FormattedMessage defaultMessage="You have to add content within 10 hours since the class ended to have 100% salary rate" />
                    }
                  >
                    <p className="text-danger">
                      <FormattedMessage defaultMessage="70% rate" />
                    </p>
                  </ToolTip>
                )}
              </FlexItem>
            </FlexGroup>
          </FlexItem>

          {/* {id === idTest && (
            <FlexItem className="items-center justify-center">
              {session.teacherCheckOut && happenedStatus !== HAPPENED && (
                <IconTip
                  type="check"
                  color="#14B24C"
                  content="The status of this session will be change to “Happened” when your student confirms."
                />
              )}
              {happenedStatus === HAPPENED && (
                <IconTip
                  type="checkInCircleFilled"
                  color="#14B24C"
                  content="This session has been confirmed by your student."
                />
              )}
              {happenedStatus === UNHAPPENED && (
                <IconTip
                  type="minusInCircleFilled"
                  color="#ED0000"
                  content="You reported the session did not happened"
                />
              )}
            </FlexItem>
          )} */}

          {!(
            courseType?.value === TRIAL_TYPE ||
            courseType?.value === TESTING_TYPE
          ) && (
            <FlexItem grow={1}>
              <Button
                fill
                className="h-full rounded-lg"
                onClick={handleOpenAttendanceModal}
                disabled={session?.happenedStatus === UNHAPPENED}
              >
                <Icon type="documentEdit" />
                <Text>
                  <FormattedMessage
                    id="Attendance"
                    defaultMessage="Attendance"
                  />
                </Text>
              </Button>
            </FlexItem>
          )}

          {canRecordFromCard && (
            <FlexItem grow={1}>
              <Button
                fill
                className="h-full rounded-lg"
                iconType="videoPlayer"
                color={isCurrentSessionRecording ? 'danger' : 'primary'}
                isLoading={isStartingRecording}
                onClick={async () => {
                  if (isCurrentSessionRecording) {
                    requestStopRecording();
                    return;
                  }

                  try {
                    setIsStartingRecording(true);
                    await startRecording(
                      String(session?.id),
                      String(session?.course_id),
                      'English',
                      `${
                        isTrialOrTestingCourse ? '[Trial/Test]' : '[Buổi học]'
                      } ${session?.title || `Session #${session?.id}`}`,
                    );
                  } finally {
                    setIsStartingRecording(false);
                  }
                }}
              >
                <Text>
                  {isCurrentSessionRecording ? (
                    <FormattedMessage defaultMessage="Stop record" />
                  ) : (
                    <FormattedMessage defaultMessage="Record session" />
                  )}
                </Text>
              </Button>
            </FlexItem>
          )}
        </FlexGroup>
      </FlexItem>
      <FlexItem grow={false} style={{ justifyContent: 'center' }}>
        <SessionActions
          courseId={session?.course_id}
          sessionId={session?.id}
          issues={session?.issues}
          isLoading={isLoading}
          happenedStatus={session?.happenedStatus}
          isLoadingSendConfirmationRequest={isLoadingSendConfirmationRequest}
          handleSendConfirmationRequest={handleSendConfirmationRequest}
          isMainCourse={
            !(
              courseType?.value === TRIAL_TYPE ||
              courseType?.value === TESTING_TYPE
            )
          }
          openAbsenceReason={openAbsenceReason}
          onUndoAbsentSession={handleUndoAbsentSession}
          openEditSessionModal={openEditSessionModal}
          // openAlertAbsence={openAlertPenaltyAbsence}
          isLoadingConfirmNo={isLoadingConfirmNo}
          isPenalty={isPenalty()}
          handleStudentNotJoinSession={handleStudentNotJoinSession}
          openReceive50Modal={openReceive50Modal}
          onViewRecordings={handleViewRecordings}
        />
      </FlexItem>
      {isVisiableAbsenceReason && (
        <AbsenceReasonModal
          close={closeAbsenceReason}
          onConfirmAbsent={handleConfirmAbsent}
          isLoading={isLoadingConfirmSession}
          session={session}
        />
      )}
      {isVisibleReceive50 && (
        <Modal onClose={closeReceive50Modal}>
          <ModalHeader>
            <ModalHeaderTitle>Student's Absence</ModalHeaderTitle>
          </ModalHeader>
          <ModalBody>Will you get 50% from this session?</ModalBody>
          <ModalFooter>
            <Button
              fill
              color="danger"
              isLoading={isLoadingConfirmNo}
              onClick={() => {
                handleStudentNotJoinSession();
              }}
            >
              No
            </Button>
            <Button
              fill
              isLoading={isLoadingConfirmNo}
              className="bg-primary ml-auto"
              onClick={() => handleStudentNotJoinSession(1)}
            >
              Yes
            </Button>
          </ModalFooter>
        </Modal>
      )}
      {/* {isVisibleConfirmNo && (
        <Modal onClose={closeConfirmNoModal}>
          <ModalHeader>
            <ModalHeaderTitle>Session not happened</ModalHeaderTitle>
          </ModalHeader>
          <ModalBody>
            <Text className="text-xs">Select the reason:</Text>
            <SuperSelect
              className="rounded-lg"
              options={Reasons}
              valueOfSelected={reasonSelected}
              onChange={value => setReasonSelected(value)}
            />
          </ModalBody>
          <ModalFooter>
            <ButtonEmpty
              className="mr-auto border border-solid border-gray rounded-lg text-gray px-4"
              onClick={closeConfirmNoModal}
            >
              Cancel
            </ButtonEmpty>
            <Button
              fill
              onClick={() => handleConfirmNo(+reasonSelected)}
              isLoading={isLoadingConfirmNo}
            >
              Confirm
            </Button>
          </ModalFooter>
        </Modal>
      )} */}
    </FlexGroup>
  );
};

export default SessionCard;
